import React, { Component } from 'react'
import moment from 'moment'
import { Input } from "../core";
import {
    data_t_GR_DETAIL
} from '../../configs/datas'
import {
    clearPODetailAction,
    getPODetailAction,
} from '../../redux/actions/MainAction'
import { connect } from 'react-redux'
import {
    updateMR_IrDescriptionAction,
} from '../../redux/actions/MRAction'


class PanelGRInvoiceDetail extends Component {
    constructor(props) {
        super(props)
    }
    render() {
        const { t_MR_IR_DESCRIPTION, delivery_note, document_date, post_date, viewMode } = this.props
        const panelStyle = {
            paddingTop: '25px',
            borderRadius: '15px',
            border: '1px solid',
            borderColor: '#a4a4a6',
            paddingBottom: "15px",
            paddingLeft: '15px',
            paddingRight: '15px'
        };
        const subHeaderLeft = {
            textAlign: 'left'
        };
        const subHeaderWeight = {
            fontWeight: 'bold'
        };
        const subHeaderPaddingLeft = {
            paddingLeft: '15px'
        };

        return (
            <div>
                <h3 className="rrs-sub-header" style={subHeaderLeft}>เอกสารการตรวจรับ</h3>
                <div className="sp-table-container">
                    <div className="row mt-0 mb-0" style={panelStyle}>
                        <div className="container">
                            <div className="row">
                                {/*                                 <div className="col-md-4">
                                    <div className="rrs-form">
                                        <label className="rrs-label" style={subHeaderWeight}>Delivery Note</label>
                                        <label className="rrs-label" style={subHeaderPaddingLeft}>{delivery_note}</label>
                                    </div>
                                </div>
 */}                                <div className="col-md-4">
                                    <div className="rrs-form">
                                        <label className="rrs-label" style={subHeaderWeight}>Document Date</label>
                                        <label className="rrs-label" style={subHeaderPaddingLeft}>{document_date}</label>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="rrs-form">
                                        <label className="rrs-label" style={subHeaderWeight}>Posting Date</label>
                                        <label className="rrs-label" style={subHeaderPaddingLeft}>{post_date}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row no-gutters sp-table-content">
                            <table className="sp-table table rrs-table">
                                <thead>
                                    <tr className="sp-table-header">
                                        <th className="th-table"><div className="th-text">No.</div></th>
                                        <th className="th-table"><div className="th-text">รายการ</div></th>
                                        <th className="th-table"><div className="th-text">รายละเอียด Invoice/ Tax Invoice No.</div></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                     t_MR_IR_DESCRIPTION && t_MR_IR_DESCRIPTION.map((row, index) =>
                                            <tr key={index}>
                                                <td><label className="label-full text-grid">{index + 1}</label></td>
                                                <td><label className="label-full text-grid">{row.short_text}</label></td>
                                                <td>
                                                   <textarea
                                                        cols={80}
                                                        key={index}
                                                        name="invoic_description"
                                                        id="invoicDescription"
                                                        className="form-control rrs-textarea"
                                                        defaultValue={row.invoic_description != null ? row.invoic_description : ''}
                                                        value={row.invoic_description != null ? row.invoic_description : ''}
                                                        //onChange={(event) => this.handleChange(event, index)}
                                                        onChange={(event) => this.props.handleChange(event, index)}
                                                        disabled={viewMode}
                                                        ref={row.invoic_description}
                                                        maxlength="255"
                                                    />

                                                </td>
                                            </tr>)
                                    }
                                </tbody>
                            </table>
                        </div>

                    </div>

                </div>
            </div>

        )
    }
}
export default PanelGRInvoiceDetail
